import { failureBatchTip, successBatchTip } from './index';
import corsImport from '../corsImport';

export const registerTip = () => {
  try {
    corsImport(`@weapp/em`).then((em) => {
      // !! setTimeout 目的 em提供的registerImNotice注册方法 执行了渲染 导致必须在ui加载之后执行
      const timer = setTimeout(() => {
        em.registerImNotice({
          cmd: 15422, // 支持15412, 15413, 15414, 15421, 15422
          msgType: '111', // 模块的对应值
          isHide: true, // 是否在首次加载的时候需要隐藏em，默认为false(不隐藏)
          callback: (message: any) => {
            // 通知回调, message为接收到的消息内容
            try {
              handleMessage(message);
            } catch (error) {}
          },
        });
        em.registerImNotice({
          cmd: 15422, // 支持15412, 15413, 15414, 15421, 15422
          msgType: '114', // 模块的对应值
          isHide: true, // 是否在首次加载的时候需要隐藏em，默认为false(不隐藏)
          callback: (message: any) => {
            // 通知回调, message为接收到的消息内容
            try {
              handleMessage(message);
            } catch (error) {}
          },
        });
        clearTimeout(timer);
      }, 2000);
    });
  } catch (error) {}
};

export const handleMessage = (message: any) => {
  try {
    const parser = JSON.parse(message.msg) || {};
    // 判断当前的任务是批量操作返回的消息
    if (parser?.batchTaskResult && parser?.content) {
      const result = parser.batchTaskResult;
      const content = parser?.content;
      const failCount = result?.failCount || 0;
      const taskId = result?.taskId;
      if (failCount !== 0 && failCount !== '0') {
        failureBatchTip({
          content,
          taskId,
          success: false,
        });
      } else {
        successBatchTip({
          content,
          taskId,
          success: true,
        });
      }
    }
  } catch (error) {}
};

// 判断当目前ui加载了之后才进行注册
export const loadedUiHandler = () => {
  let cnt = 0;
  let timer = setInterval(() => {
    cnt++;
    if (window.weappUi) {
      registerTip();
      clearInterval(timer);
    }

    // 当循环次数超过60的情况下 未清除 手动清除
    if (cnt >= 60) {
      clearInterval(timer);
    }
  }, 1000);
};

// loadedUiHandler();
